<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <b-row class="d-flex justify-content-between align-items-start match-height mb-2">
      <b-col
        md="7"
        class="d-flex flex-column"
      >
        <b-card-title class="section-title mb-1">
          Quick Links
        </b-card-title>
        <ul class="bulletin-list">
          <li
            v-for="(link, index) in quickLinks"
            :key="index"
          >
            <router-link
              v-if="link.isShow"
              :to="{ path: link.url }"
            >
              <span class="support-label mr-1">{{ link.label }}</span>

              <span
                v-if="link.status"
                class="status-badge"
              >
                {{ link.status }}
              </span>
            </router-link>
            <span
              v-else
              class="support-label disabled"
            >
              {{ link.label }}
            </span>
          </li>
          <Spinner :show="isLoading" />
        </ul>
      </b-col>

      <b-col
        md="5"
        class="d-flex flex-column"
      >
        <b-card-title class="section-title mb-1">
          Exportable Reports
        </b-card-title>
        <ul class="bulletin-list">
          <li
            v-for="(report, index) in exportableReportLinks"
            :key="index"
          >
            <router-link
              class="support-label disabled"
              :to="{ path: report.url }"
            >
              {{ report.label }}
            </router-link>
          </li>
          <Spinner :show="isLoadingExport" />
        </ul>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard,
  BCardTitle,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import addSpaceToString from '../../../helpers/addSpaceToString'
import Spinner from '@/views/components/spinner/Spinner.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    Spinner,
  },
  data() {
    return {
      isLoading: false,

      quickLinks: [],
      exportableReportLinks: [
        { label: 'Loan Summary Report', url: '' },
        { label: 'Repayment Schedule', url: '' },
        { label: 'Beneficiary Portfolio data', url: '' },
      ],
    }
  },
  mounted() {
    this.fetchQuickLinks()
  },
  methods: {
    ...mapActions({
      getQuickLinks: 'dashboard/getQuickLinks',
    }),
    async fetchQuickLinks() {
      try {
        this.isLoading = true
        const response = await this.getQuickLinks({
          permission: 'VIEW_PFI_DASHBOARD',
        })
        const { status, data } = response

        if (status === 200 && data.quickLinks.length) {
          this.quickLinks = data.quickLinks.map(item => ({
            label: item.title, url: `/lms${item.route}`, isShow: item.shouldShow, status: item.status === 'Pending' ? 'Pending Review' : addSpaceToString(item.status),
          }))
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
.section-title{
  font-weight: 800;
}

.bulletin-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.bulletin-list li {
  margin-bottom: 0.5rem;
}

.support-label {
  text-decoration: none;
  transition: color 0.2s ease;
  font-size: 13px;
  line-height: 27px;
}

.support-label:hover {
  text-decoration: underline;
}

.support-label.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.text-muted {
  color: #6c757d;
}
.status-badge {
  font-size: 11px;
  /* line-height: 18px; */
  color: var(--white);
  background: var(--primary);
  border-radius: 4px;
  padding: 4px 8px;
}
</style>
